import React from "react";
import classNames from "classnames";
import { FormPostSubmitType, FormSettings, TextObject } from "@/shared/types";
import CloseIcon from "@/shared/icons/CloseIcon";
import styles from "./FeedbackMessage.module.scss";

interface FeedbackMessageProps {
  formSettings?: FormSettings;
  success?: boolean;
  failure?: boolean;
  resetForm?: () => void;
  text: TextObject;
}

const FeedbackMessage: React.FC<FeedbackMessageProps> = ({
  success,
  failure,
  formSettings,
  resetForm,
  text,
}) => {
  const successMessage = formSettings?.formPostSubmit?.successMessage;
  const failureMessage = formSettings?.formPostSubmit?.failureMessage;
  const postSubmitType = formSettings?.formPostSubmit?.submitType;

  if (!success && !failure) return null;
  if (success && !text[successMessage?.textId!]) return null;
  if (failure && !text[failureMessage?.textId!]) return null;
  if (postSubmitType !== FormPostSubmitType.Message) return null;

  return (
    <div
      className={classNames({
        [styles.feedbackMessage]: true,
        [styles.success]: success,
        [styles.fail]: failure,
      })}
    >
      <div>
        {success
          ? text[successMessage?.textId!]
          : text[failureMessage?.textId!]}
      </div>
      <button className={styles.closeButton} onClick={resetForm}>
        <CloseIcon />
      </button>
    </div>
  );
};

export default FeedbackMessage;
